// import moment from 'moment';
import moment from 'moment-timezone';
import Radio from 'backbone.radio';
var globalCh = Radio.channel('global');

  export default function(options) {
    // 29 Sep 2016
    let primary = globalCh.request('primary_account');
    let timezone = primary.get_timezone();
    let mts = moment(options.fn(this)).tz(timezone);
    return mts.format('YYYY-MM-DD');
  }
